<template>
  <div class="content-right">
    <div class="content-wrapper container-xxl p-0">
      <div class="content-header row">
      </div>
      <div class="content-body">
        <div class="body-content-overlay"></div>
        <!-- Main contact area -->
        <section class="chat-app-window">
          <!-- To load Conversation -->
          <div v-if="!contactInfo.full_name" class="start-chat-area">
            <div class="mb-1 start-chat-icon">
              <i data-feather="message-square"></i>
            </div>
            <h4 class="sidebar-toggle start-chat-text">Select Patient</h4>
          </div>
          <!--/ To load Conversation -->

          <!-- Active Contact -->
          <div v-if="contactInfo.full_name" class="active-chat">
            <!-- Contact Header -->
            <div class="chat-navbar">
              <header class="chat-header">
                <div class="d-flex align-items-center">
                  <div @click="$emit('sidebarActiveInactive')" class="sidebar-toggle d-block d-lg-none me-1">
                    <svg class="svg-inline--fa fa-bars" data-v-187c8d15="" aria-hidden="true" focusable="false"
                         data-prefix="fas" data-icon="bars" role="img" xmlns="http://www.w3.org/2000/svg"
                         viewBox="0 0 448 512" data-fa-i2svg="">
                      <path fill="currentColor"
                            d="M0 96C0 78.33 14.33 64 32 64H416C433.7 64 448 78.33 448 96C448 113.7 433.7 128 416 128H32C14.33 128 0 113.7 0 96zM0 256C0 238.3 14.33 224 32 224H416C433.7 224 448 238.3 448 256C448 273.7 433.7 288 416 288H32C14.33 288 0 273.7 0 256zM416 448H32C14.33 448 0 433.7 0 416C0 398.3 14.33 384 32 384H416C433.7 384 448 398.3 448 416C448 433.7 433.7 448 416 448z"></path>
                    </svg>
                  </div>
                  <div class="avatar avatar-border user-profile-toggle m-0 me-1">
                    <img :src="contactInfo.photo" width="42" class="border-0" :alt="contactInfo.full_name"/>
                  </div>
                  <h6 class="mb-0">
                    {{ contactInfo.full_name }}<br>
                    <small v-for="profile_item in contactInfo.profile_items">
                      {{ profile_item.value }}<br>
                    </small>
                  </h6>
                </div>
               <div class="d-flex">
                 <div @click="goRoute('sticker-printer')" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="tab" class="btn btn-success">Sticker Printer</h5>
                 </div>
                 <div @click="goRoute('patient-card-print')" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="tab" class="btn btn-primary">Patient Card</h5>
                 </div>
                 <div @click="$emit('handleEdit', contactInfo)" class="d-flex align-items-center me-md-3 me-lg-3">
                   <h5 role="button" class="btn btn-dark">Profile</h5>
                 </div>
               </div>
              </header>
            </div>
            <!--/ Contact Header -->

            <!-- User Chat messages -->
            <div class="user-chats">
              <div class="chats">
                <ul class="nav nav-tabs">
                  <li v-for="tab in tabs" :key="tab.id" class="nav-item">
                    <a
                        :class="['nav-link', { active: activeTabId === tab.id }]"
                        @click="setActiveTab(tab)"
                    >
                      {{ tab.title }}
                    </a>
                  </li>
                </ul>
                <component :is="activeTab" :contactDetails="contactDetails" :contactInfo="contactInfo"/>
              </div>
            </div>
            <!-- User Contact messages -->
          </div>
          <!--/ Active Contact -->
        </section>
        <!--/ Main contact area -->
      </div>
    </div>
  </div>
</template>

<script setup>
import Statements from "@/views/page/company/contact/register/tabs/Statements";
import MoneyReceipts from "@/components/molecule/company/hospital/patient/register/tabs/MoneyReceipts";
import OPD from "@/components/molecule/company/hospital/patient/register/tabs/OPD.vue";
import IPD from "@/components/molecule/company/hospital/patient/register/tabs/IPD.vue";
import Investigation from "@/components/molecule/company/hospital/patient/register/tabs/Investigation.vue";
import Medicine from "@/components/molecule/company/hospital/patient/register/tabs/Medicine.vue";

import Attachment from "@/components/molecule/company/hospital/patient/register/tabs/Attachment.vue";
import Note from "@/components/molecule/company/hospital/patient/register/tabs/Note.vue";
import Message from "@/components/molecule/company/hospital/patient/register/tabs/Message.vue";
import Email from "@/components/molecule/company/hospital/patient/register/tabs/Email.vue";
import Call from "@/components/molecule/company/hospital/patient/register/tabs/Call.vue";
import {onMounted, ref, watch} from "vue";
import {useRoute, useRouter} from "vue-router";

const activeTab = ref(Statements)
const props = defineProps({
  contactInfo: {
    type: Object,
    default: {
      full_name: '',
      profile_items: [],
      contact: {},
    }
  },
  contactDetails: {
    type: Array,
    default: []
  }
})

const router = useRouter();
const route = useRoute();
const activeTabId = ref("statements")

const tabs = [
  {id: 'statements', title: 'Statements', component: Statements},
  {id: 'money-receipts', title: 'MoneyReceipts', component: MoneyReceipts},
  {id: 'opd', title: 'OPD', component: OPD},
  {id: 'ipd', title: 'IPD', component: IPD},
  {id: 'investigation', title: 'Investigation', component: Investigation},
  {id: 'medicine', title: 'Medicine', component: Medicine},
  {id: 'attachment', title: 'Attachment', component: Attachment},

  {id: 'note', title: 'Note', component: Note},
  {id: 'message', title: 'Message', component: Message},
  {id: 'email', title: 'Email', component: Email},
  {id: 'call', title: 'Call', component: Call},
]

watch(activeTabId, () => {
  activeTab.value = tabs.find(tab => tab.id === activeTabId.value).component
  let routeQuery = Object.assign({}, route.query)
  routeQuery.tab = activeTabId.value;
  routeQuery.page = 1;
  router.push({
    path: route.path,
    query: routeQuery
  })
})

const setActiveTab = tab => {
  activeTabId.value = tab.id;
};

const goRoute = (routeName = 'sticker-printer') => {
  router.push({name: routeName, params: {patientId: props.contactInfo.id}})
}

onMounted(() => {
  if (route.query.tab) {
    activeTabId.value = route.query.tab;
  }
})

</script>

<style scoped>
.user-chats {
  background-image: none !important;
  overflow-y: scroll;
  height: calc(100% - 65px);
  overflow-x: hidden;
}
</style>
